// extracted by mini-css-extract-plugin
export default {"navbar":"AltNavbar_navbar__iw6lX","logo":"AltNavbar_logo__P1Ljs","links":"AltNavbar_links__Xxka8","link":"AltNavbar_link__-7qxx","dropdown":"AltNavbar_dropdown__6+xXI"};